import React, { useEffect, useState } from "react";
import { ActiveIconColor, ButtonCommonTopNew } from "../pages/Theme";
import { trimString, addAttribute } from "./Helpers/Common";
import { useHistory, useLocation, Link } from "react-router-dom";
import { staticFiles } from "./Helpers/Static";
import { MdOutlineClose, MdEdit } from 'react-icons/md';
import moment from "moment";
import { convertDateFormat } from './Helpers/Common';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { TbShareOff } from "react-icons/tb";
import Tooltip from '@mui/material/Tooltip';
import { BiEditAlt } from "react-icons/bi";
import ReflectionCardRichText from './Editor/ReflectionCardRichText';

const imageIcon = staticFiles.editIcon;

export const AnnounceReader = ({ data, groupId, handleDelete, isAccess, gridView }) => {

    const history = useHistory()
    const location = useLocation()

    const handleDeletePost = (id) => {
        handleDelete(id);
    }
    const [readMore, setReadMore] = useState(false)
    //----------------------------------------------------------------------------------------------------------------------------- 
    return (<>
        <div className={`${'cardBackgroundColor shadow-sm border20px overflow-hidden relative cursor-pointer w-full p-6'}`} onClick={() => history.push(`/announcement/${data.announcement_id}`, { src: location.pathname, id: groupId })}>
            <div className="flex flex-col justify-between h-full">
                <div className=''>
                    <div className='flex flex-col sm:flex-row items-center gap-2 justify-between'>
                        <div className='blackColor text-lg font-bold'>{trimString(data.announcement_title, 50)}</div>
                        <div className="flex flex-col sm:flex-row items-center gap-2 justify-end">
                            <div className="text-sm lightColor">
                                {moment.utc(data.announcement_created_on).local().startOf('seconds').fromNow()} ({convertDateFormat(data.announcement_created_on)})
                            </div>
                            {(isAccess == "MANAGER" && data.is_from_group == true) ?
                                <div className='flex items-center gap-1' onClick={(e) => e.stopPropagation()}>
                                    <Tooltip title={"Edit announcement"} placement="top" arrow>
                                        <ButtonCommonTopNew className="pl-2 pr-2 pt-0.5 pb-1 cursor-pointer rounded-lg" onClick={() => history.push(`/community/editannouncement/${data.announcement_id}`, { src: location.pathname, id: groupId })}>
                                            <BorderColorOutlinedIcon className="w-4 h-4 cursor-pointer primaryIcon editIcon" />
                                        </ButtonCommonTopNew>
                                    </Tooltip>
                                    {
                                        data.announcement_id &&
                                        <Tooltip title={"Unshare announcement"} placement="top" arrow>
                                            <ButtonCommonTopNew className="p-2 cursor-pointer rounded-lg" onClick={() => handleDeletePost(data.announcement_id)}>
                                                <TbShareOff className='primaryIcon w-4 h-4 cursor-pointer' />
                                            </ButtonCommonTopNew>
                                        </Tooltip>
                                    }
                                </div> : ""}
                        </div>
                    </div>
                    <div className='py-2 overflow-hidden'>
                        <div className="text-viewer flex-1 text-sm lg:text-base break-words font-normal mb-3 container-multi overflow-wrap-break-word">
                            <ReflectionCardRichText
                                htmlContent={addAttribute(data.announcement_desc)}
                                maxLines={6}
                                setReadMore={setReadMore}
                            />
                        </div>
                    </div>
                </div>
                <div className=''>
                    <div className='flex flex-col md:flex-row gap-1.5 items-center justify-between py-2'>
                        {readMore &&
                            <div className="justify-start whitespace-nowrap flex blueColor cursor-pointer hover:underline">
                                Read More...
                            </div>}
                        <div className="justify-end flex gap-2 w-full">
                            <div className="flex gap-1">
                                <p className="text-sm lightColor pt-0.5">By</p>
                                <Link className="nav-navigate font-semibold" title={data.fullname} to={"/profile/" + data.guid} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                                    <ActiveIconColor className="hover:underline">{trimString(data.fullname, 55)}</ActiveIconColor>
                                </Link>
                            </div>
                            {data.group_name ?
                                <div className='flex flex-col md:flex-row' onClick={(e) => e.stopPropagation()}>
                                    <div className="flex gap-1">
                                        <p className="text-sm lightColor pt-0.5">In</p>
                                        {location.pathname === `/community/groups/${data.group_id}` ?
                                            <p title={data.group_name} className="blackColor font-semibold text-base">{trimString(data.group_name, 55)}</p>
                                            :
                                            <a
                                                className="cursor-pointer nav-navigate font-semibold"
                                                onClick={() => history.push(`/community/groups/${data.group_id}`, { src: location.pathname })} title={data.group_name}>
                                                <ActiveIconColor className="hover:underline">{trimString(data.group_name, 55)}</ActiveIconColor>
                                            </a>
                                        }
                                    </div>
                                </div>
                                : <></>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}